export enum ApprovalEmailType {
    VerifyTax = 1,
    VerifyPayStub = 2,
    VerifyExpense = 3,
    VerifyAmount = 4
}